var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action"},[_vm._v("操作手册")])
}
var staticRenderFns = []

export { render, staticRenderFns }